import React, { useState, useCallback } from 'react';
import Button from './Button';

const CounterGrid = () => {
  const [counters, setCounters] = useState({
    dialed: 0,
    answered: 0,
    interested: 0,
    notInterested: 0,
    demoBooked: 0,
  });

  const handleIncrement = useCallback((counterName) => {
    setCounters(prev => ({
      ...prev,
      [counterName]: prev?.[counterName] + 1
    }));
  }, []);

  const handleReset = useCallback(() => {
    const confirmed = window.confirm(
      'Are you sure you want to reset all counters? This action cannot be undone.'
    );
    
    if (confirmed) {
      setCounters({
        dialed: 0,
        answered: 0,
        interested: 0,
        notInterested: 0,
        demoBooked: 0,
      });
    }
  }, []);

  const counterConfig = [
    { key: 'dialed', label: 'Calls Dialed', icon: 'Phone' },
    { key: 'answered', label: 'Calls Answered', icon: 'PhoneCall' },
    { key: 'interested', label: 'Interested Leads', icon: 'ThumbsUp' },
    { key: 'notInterested', label: 'Not Interested', icon: 'ThumbsDown' },
    { key: 'demoBooked', label: 'Demos Booked', icon: 'Calendar' },
  ];

  return (
    <div className="counter-grid-container">
      <div className="counter-grid">
        {counterConfig?.map(({ key, label, icon }) => (
          <div key={key} className="counter-card">
            <div className="counter-label">{label}</div>
            <div className="counter-value font-data">{counters?.[key]}</div>
            <Button
              variant="default"
              size="lg"
              fullWidth
              iconName={icon}
              iconPosition="left"
              iconSize={24}
              onClick={() => handleIncrement(key)}
              className="counter-button"
            >
              Add {label?.split(' ')?.[0]}
            </Button>
          </div>
        ))}
      </div>
      <div className="reset-button-container">
        <Button
          variant="destructive"
          size="lg"
          iconName="RotateCcw"
          iconPosition="left"
          iconSize={20}
          onClick={handleReset}
          className="reset-button"
        >
          Reset All Counters
        </Button>
      </div>
    </div>
  );
};

export default CounterGrid;